import {
	ALIGN_LEFT,
	ALIGN_CENTER,
	ALIGN_RIGHT,
} from '@techchange/pm-specs/src/specs/nodes/paragraph.js';
import { keymap } from 'prosemirror-keymap';

import { toggleAlignment } from '../commands';

const alignKeymap = keymap({
	'Mod-L': toggleAlignment({ align: ALIGN_LEFT }),
	'Mod-E': toggleAlignment({ align: ALIGN_CENTER }),
	'Mod-R': toggleAlignment({ align: ALIGN_RIGHT }),
});

export default alignKeymap;
